import {
  getApplicantNotAttended,
  addApplicantAttend,
  getExamCenters,
} from "../../../store/recruitment/actions";
import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import PreLoader from "../../common/components/PreLoader";
import NoRecordMessage from "../../common/components/NoRecordMessage";
import MaskedInput from "react-text-mask";
import { Autocomplete, Box, TextField } from "@mui/material";
import ErrorMessage from "../../common/components/ErrorMessage";
import { showError } from "../../toastify";
export const idNumberPattern = [
  /\d/,
  " ",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  " ",
  /\d/,
  " ",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  " ",
  /\d/,
  " ",
  /\d/,
  /\d/,
];

const WrittenExamApplicantsNotAttended = (props) => {
  const {
    loading,
    examId,
    examTypeId,
    applicantsNotAttended,
    getApplicantNotAttended,
    addApplicantAttend,
    getExamCenters,
    examCenters,
    center,
    disableCentersOption,
  } = props;

  const [applicantId, setApplicantId] = useState("0");
  const [isLoading, setIsLoading] = useState(false);
  const [idNumber, setIdNumber] = useState("");
  const [examCenter, setExamCenter] = useState(
    center ? center : examCenters.length === 1 ? examCenters[0] : null
  );
  const [errors, setErrors] = useState({
    examCenterError: false,
  });

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: "SET_EXAM_CENTERS",
      data: [],
    });
    dispatch({
      type: "SET_APPLICANTS_NOT_ATTENDED",
      data: [],
    });
  }, []);

  useEffect(() => {
    getExamCenters(examId);
  }, [examId]);

  return (
    <>
      <div className="row mt-0">
        <div className="col-12">
          <MaskedInput
            mask={idNumberPattern}
            className="form-control"
            placeholder="Enter Id Number"
            guide={false}
            value={idNumber}
            onKeyPress={(e) => {
              if (e.key === "Enter" && !!e.target.value.length >= 1) {
                setIdNumber(e.target.value);
                setApplicantId("0");
                getApplicantNotAttended(
                  examId,
                  examTypeId,
                  e.target.value,
                  setIsLoading
                );
              }
            }}
            onChange={(e) => {
              if (e.target.value.length === 21) {
                setApplicantId("0");
                setIdNumber(e.target.value);
                getApplicantNotAttended(
                  examId,
                  examTypeId,
                  e.target.value,
                  setIsLoading
                );
              }
            }}
          />
        </div>

        <div className="col-12 mt-2">
          {!!applicantsNotAttended.length && (
            <>
              <table className="rounded" style={{ overflowY: "auto" }}>
                <tbody>
                  <tr>
                    <th scope="row">Names</th>
                    <td>
                      <span style={{ fontSize: "14px" }}>
                        {applicantsNotAttended[0].lastName.toUpperCase()}{" "}
                        {applicantsNotAttended[0].firstName.toUpperCase()}
                      </span>
                    </td>
                  </tr>

                  <tr>
                    <th scope="row">Email</th>
                    <td>
                      {" "}
                      <span style={{ fontSize: "14px" }}>
                        {applicantsNotAttended[0].email}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Phone</th>
                    <td>
                      <span style={{ fontSize: "14px" }}>
                        {applicantsNotAttended[0].phoneNumber}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">IDNumber</th>
                    <td>
                      <span style={{ fontSize: "14px" }}>
                        {applicantsNotAttended[0].idNumber}
                      </span>
                    </td>
                  </tr>

                  <tr>
                    <th scope="row">AssignCenter</th>
                    <td>
                      <Autocomplete
                        size="small"
                        id="examCenter"
                        disabled={disableCentersOption}
                        defaultValue={null}
                        value={examCenter}
                        options={examCenters}
                        isOptionEqualToValue={(option, value) =>
                          option.id === value.id
                        }
                        onChange={(event, examCenter) => {
                          setExamCenter(examCenter || null);
                          setErrors({
                            ...errors,
                            panelError: false,
                          });
                        }}
                        getOptionLabel={(option) => option?.center?.name}
                        renderOption={(props, examCenter) => (
                          <Box component="li" {...props}>
                            {examCenter?.center?.name}
                          </Box>
                        )}
                        renderInput={(params) => (
                          <TextField
                            disabled={disableCentersOption}
                            required={true}
                            {...params}
                            label="Select center"
                            placeholder="Select center"
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: "examCenter", // disable autocomplete and autofill
                            }}
                          />
                        )}
                      />
                      <ErrorMessage
                        hasError={errors.examCenterError}
                        message="center is required"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} className="text-center">
                      {" "}
                      <button
                        onClick={() => {
                          let examCenterError = false;
                          if (!examCenter) {
                            examCenterError = true;
                          }
                          setErrors({
                            ...errors,
                            examCenterError,
                          });
                          if (!examCenter) {
                            showError("Center is required");
                          } else {
                            setApplicantId(applicantsNotAttended[0].id);
                            addApplicantAttend(
                              {
                                ...applicantsNotAttended[0],
                                examId,
                                examTypeId,
                                examCenterId: examCenter?.id,
                              },
                              setApplicantId,
                              setIdNumber
                            );
                          }
                        }}
                        disabled={applicantId === applicantsNotAttended[0].id}
                        className="btn btn-success"
                      >
                        {applicantId === applicantsNotAttended[0].id ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                            ></span>
                            <span className="sr-only">Loading...</span>
                          </>
                        ) : (
                          <>Add</>
                        )}
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </>
          )}

          <NoRecordMessage
            isEmpty={!applicantsNotAttended.length && !isLoading}
            title="No Result"
          />

          <PreLoader isLoading={isLoading && !applicantsNotAttended.length} />
        </div>
      </div>
    </>
  );
};

const mapStateToProps = ({ loading, applicantsNotAttended, examCenters }) => {
  return {
    loading,
    applicantsNotAttended,
    examCenters,
  };
};
export default connect(mapStateToProps, {
  getApplicantNotAttended,
  addApplicantAttend,
  getExamCenters,
})(WrittenExamApplicantsNotAttended);
